<template>
  <div>
    <el-dialog
      title="课程老师"
      :visible.sync="dialogVisible"
      @close="handleCloseDialog"
      width="30%"
    >
      <el-form
        ref="form"
        label-width="65px"
        inline
        @submit.native.prevent
        size="mini"
        :model="form"
        class="teacher-form"
      >
        <el-form-item label="已关联">
          <div v-if="form.teacherCheckedData.length > 0">
            <div v-for="item in form.teacherCheckedData" :key="item.staff_id">
              <span style="margin-right: 5px; color: #07d1aa">
                {{ item.name }}
              </span>
              <i
                class="el-icon-close"
                style="cursor: pointer"
                @click="handleDelete(item)"
              ></i>
            </div>
          </div>
          <div v-else>-</div>
        </el-form-item>

        <el-form-item label="新增">
          <el-select
            v-model="form.teacher_id"
            placeholder="请选择"
            clearable
            filterable
            :filter-method="handleSearchTeacher"
            @visible-change="handleVisibleTeacher"
          >
            <el-option
              v-for="item in teacherList"
              :key="item.staff_id"
              :label="item.name"
              :value="item.staff_id"
              :disabled="item.disabled"
              style="background: transparent !important"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="add-confirm">
          <div
            class="mwow-button-filled primary"
            v-if="form.teacher_id"
            @click="handleConfirm"
          >
            确定
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="备注原因"
      :visible.sync="remarkDialogVisible"
      append-to-body
      width="500px"
      @close="handleCloseRemark('auto')"
    >
      <el-input
        type="textarea"
        v-model="form.remark"
        placeholder="请填写原因（必填），最多可输入100字"
        maxlength="100"
      ></el-input>
      <div class="flex remark-btns">
        <el-button type="success" size="mini" @click="handleRemarkSubmit">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { staffList } from "@/api/globalSearch";
import {
  relationStudentRelationApi,
  relationStudentReleaseApi,
} from "@/api/teacherManage";

export default {
  props: ["visible", "originData"],
  data() {
    return {
      form: {
        teacher_id: "",
        teacher_id_cache: "",
        teacherCheckedData: [], // 课程老师
        student_name: "", // 变更时的学员姓名
        course_title: "", // 变更时的课程名称
        remark: "",
      },
      teacherList: [],
      dialogVisible: false,
      remarkDialogVisible: false,
    };
  },
  watch: {
    visible: {
      handler(n) {
        if (n) {
          this.form = this.originData;
          this.dialogVisible = n;
          // console.log("watch", this.form);
        }
      },
    },
  },

  methods: {
    getTeacherList(val) {
      staffList({
        page: 1,
        page_size: 50,
        status: 1,
        key_word: val || "",
        job_ids: [1],
      }).then((res) => {
        if (res.error_code === 0) {
          this.teacherList = res.data.list;
          let staffId = this.form.teacherCheckedData.map((item) => {
            return item.staff_id;
          });
          this.teacherList.forEach((item) => {
            if (staffId.includes(item.staff_id)) {
              item.disabled = true;
            }
          });
        }
      });
    },
    handleConfirm() {
      if (!this.form.teacher_id) return;
      let name;
      this.teacherList.forEach((item) => {
        if (item.staff_id === this.form.teacher_id) {
          name = item.name;
        }
      });
      this.$confirm(
        `确认把${name}老师关联为${this.form.student_name}学员${this.form.course_title}的课程老师?`,
        "新增关联",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
        }
      )
        .then(() => {
          relationStudentRelationApi({
            teacher_id: this.form.teacher_id,
            student_id: this.form.student_id,
            course_id: this.form.course_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.form.teacher_id = "";
              this.$message({
                message: "新增关联成功",
                type: "success",
              });
              this.handleCloseDialog();
              this.$emit("change");
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    handleSearchTeacher(val) {
      this.getTeacherList(val);
    },
    handleVisibleTeacher(rest) {
      if (rest) {
        this.getTeacherList();
      }
    },
    handleDelete(item) {
      this.$confirm(
        `学员：${this.form.student_name}<br/>
        课程：${this.form.course_title}<br/>
        课程老师：${item.name}<br/>
        解绑后。状态将从“授课中”变更成“<span class="mwow-red">已流失</span>”请谨慎操作！<br/>
        <span class="mwow-yellow">希望只是移除授课中状态，不产生流失数据？请移步至【教师管理】->【教师学员】进行【调班】操作。</span>`,
        "解绑课程老师",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.remarkDialogVisible = true;
          this.form.teacher_id_cache = item.staff_id;
        })
        .catch(() => {});
    },
    handleCloseRemark() {
      this.form = {
        ...this.form,
        teacher_id_cache: "",
        remark: "",
      };
      this.remarkDialogVisible = false;
    },
    handleRemarkSubmit() {
      relationStudentReleaseApi({
        teacher_id: this.form.teacher_id_cache,
        student_id: this.form.student_id,
        course_id: this.form.course_id,
        remark: this.form.remark,
      }).then((res) => {
        if (res.error_code === 0) {
          this.form = {
            ...this.form,
            teacher_id: "",
            remark: "",
          };
          this.handleCloseRemark();
          this.$message({
            message: "取消关联成功",
            type: "success",
          });
          this.$emit("change");
          this.handleCloseDialog();
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    handleCloseDialog() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .teacher-form {
  .el-form-item {
    width: 100%;
    display: flex;
    .el-form-item__label {
      text-align: right !important;
    }
    .el-form-item__content {
      width: 100%;
      flex: 1;
      margin-right: 0 !important;
      .el-select {
        width: 90%;
        margin-right: 20px;
      }
    }
  }
  .add-confirm {
    width: 91%;
    .el-form-item__content {
      display: flex;
      justify-content: flex-end;
    }
  }
}
.remark-btns {
  justify-content: center !important;
  padding-top: 10px;
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
